<template src='./newAtributeModal.pug' lang='pug'></template>

<script>
import vSelect from 'vue-select'
import InputTag from 'vue-input-tag'
import BetterModal from '../../modals/betterModal/BetterModal'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import { normalize, removeNonAlphanumeric } from '../../../utils/stringUtils.js'

export default {
  name: 'NewAtributeModal',

  components: {
    vSelect,
    InputTag,
    BetterModal,
    ButtonPrimary
  },

  props: {
    editingAttribute: {
      type: Object
    },
    attributesList: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      isEditing: false,
      attributeTypeHint: '',
      types: [],
      possibleValues: [],
      availableFields: {
        value: false,
        mask: false,
        validation: false
      },
      attribute: {
        name: '',
        description: null,
        type: {
          key: '',
          description: ''
        },
        possibleValues: [],
        inUse: false
      },
      tagsPossibleValue: [],
      typesValues: {
        COMBO: {
          hintText: this.$t('conjuntoAtributo.infos.combo'),
          availableFields: {
            value: true,
            mask: false,
            validation: false
          }
        },
        NUMBER: {
          hintText: this.$t('conjuntoAtributo.infos.numerico'),
          availableFields: {
            value: false,
            mask: true,
            validation: true
          }
        },
        STRING: {
          hintText: this.$t('conjuntoAtributo.infos.texto'),
          availableFields: {
            value: false,
            mask: true,
            validation: true
          }
        },
        DATE: {
          hintText: this.$t('conjuntoAtributo.infos.datepicker'),
          availableFields: {
            value: false,
            mask: false,
            validation: false
          }
        }
      }
    }
  },

  watch: {
    attribute: {
      handler () {
        this.possibleValuesChanged(null)
      },
      deep: true
    }
  },

  methods: {
    handleIdentifier (evnt) {
      this.attribute.name = removeNonAlphanumeric(normalize(this.attribute.name)).toUpperCase()
    },

    validate () {
      const self = this
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            self.save()
          } else {
            self.$root.$refs.notification.error('conjuntoAtributo.erro.camposObrigatorios')
          }
        })
    },

    save () {
      if (this.attribute.type.key === 'COMBO') {
        this.attribute.possibleValues = [...this.possibleValues]
      } else {
        this.attribute.possibleValues = []
      }

      let newList = [...this.attributesList]

      if (this.isEditing) {
        const index = this.attributesList.findIndex(att => att === this.editingAttribute)
        if (index === -1) {
          throw new Error('Not found')
        }
        newList.splice(index, 1, this.attribute)
      } else {
        newList.push(this.attribute)
      }
      this.$emit('update-list-attributes', newList)
      this.close()
    },

    toggleAditionalFields (selectedType) {
      if (!selectedType || !selectedType.key || !selectedType.description) {
        return
      }

      if (!this.attribute.type) {
        this.attribute.type = {}
      }

      this.attribute.type.key = selectedType.key
      this.attribute.type.description = selectedType.description

      const typeValues = this.typesValues[selectedType.key]
      if (!typeValues) {
        return
      }

      this.availableFields = { ...typeValues.availableFields }
    },

    possibleValuesChanged (list) {
      if (!list) {
        list = [...this.attribute.possibleValues]
      }
      this.tagsPossibleValue = [...list]
      this.possibleValues = list.map(value => {
        return {
          id: null,
          value
        }
      })
    },

    close () {
      this.$emit('close-modal')
    }
  },

  created () {
    this.$store.dispatch('loadAttributeTypes')
      .then(types => {
        this.types = types.map(type => {
          type.key = type.tipo
          type.description = this.$t(type.descricao)
          return type
        })
      })
      .catch(error => this.$root.$refs.notification.error(error.message))
    if (this.editingAttribute) {
      this.isEditing = true
      this.attribute = { ...this.editingAttribute }
      this.attribute.type.description = this.$t(this.attribute.type.description)
      this.attribute.possibleValues = this.editingAttribute.possibleValues.map(tag => tag.value)
      this.tagsPossibleValue = [...this.attribute.possibleValues]
      this.possibleValues = this.editingAttribute.possibleValues
      this.toggleAditionalFields(this.editingAttribute.type)
    }
    this.defaultObject = { ...this.attribute }
  }
}
</script>

<style scoped>
.alert-icon {
  margin-right: 10px;
  color: red;
  font-size: 20px;
}

.alert-text {
  color: red;
  font-size: 15px;
}

.att-field-hint {
  margin: 0 auto;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  padding-left: 0 !important;
  color: #b7b7b7;
}

span.info-span {
  font-style: italic;
  margin-left: 5px;
}

span.hint-span {
  font-style: italic;
}

.to-upper {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// NewAtributeModal.vue?4c9f36a9